'use client';

import { c as _c } from "react/compiler-runtime";
import { unwrapFromResult } from '@shared/utils/helpers/resultWrapper';
import toast from '@shared/utils/helpers/toast';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { PLATFORM_BRAND } from '../../utils/platformBrand';
import { client } from '../../utils/trpc';
import AppCard from './AppCard';
import { useOAuthReturn } from './useOAuthReturn';
type Props = {
  autoEnabled: boolean;
  issue?: boolean;
  onToggleAuto: () => void;
};
const TiktokCard = t0 => {
  const $ = _c(13);
  const {
    autoEnabled,
    issue,
    onToggleAuto
  } = t0;
  const queryClient = useQueryClient();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      queryKey: ["tiktokHasToken"],
      queryFn: _temp,
      retry: false
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    data: status,
    isLoading
  } = useQuery(t1);
  let t2;
  if ($[1] !== queryClient) {
    t2 = async (code, state) => {
      const [error, data] = await client.platforms.tiktok.connect.mutate({
        code,
        state
      });
      if (error) {
        toast(error.message || "Failed to connect TikTok");
        return;
      }
      toast(`TikTok connected as ${data?.displayName ?? "your account"}`);
      await queryClient.invalidateQueries({
        queryKey: ["tiktokHasToken"]
      });
    };
    $[1] = queryClient;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  useOAuthReturn("tiktok", "TikTok", t2);
  const connect = _temp2;
  let t3;
  if ($[3] !== queryClient) {
    t3 = async () => {
      const [error_1] = await client.platforms.tiktok.disconnect.mutate();
      if (error_1) {
        toast(error_1.message || "Failed to disconnect TikTok");
        return;
      }
      toast("TikTok account disconnected.");
      await queryClient.invalidateQueries({
        queryKey: ["tiktokHasToken"]
      });
    };
    $[3] = queryClient;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const disconnect = t3;
  const t4 = !!status?.hasToken;
  const t5 = status?.displayName ? `Connected as ${status.displayName}` : undefined;
  let t6;
  if ($[5] !== autoEnabled || $[6] !== disconnect || $[7] !== isLoading || $[8] !== issue || $[9] !== onToggleAuto || $[10] !== t4 || $[11] !== t5) {
    t6 = <AppCard label="TikTok" brand={PLATFORM_BRAND.TIKTOK} loading={isLoading} connected={t4} accountText={t5} supports="Cross-posts videos and photos" autoEnabled={autoEnabled} issue={issue} onConnect={connect} onDisconnect={disconnect} onToggleAuto={onToggleAuto} />;
    $[5] = autoEnabled;
    $[6] = disconnect;
    $[7] = isLoading;
    $[8] = issue;
    $[9] = onToggleAuto;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};
export default TiktokCard;
function _temp() {
  return unwrapFromResult(client.platforms.tiktok.hasToken.query());
}
async function _temp2() {
  const [error_0, data_0] = await client.platforms.tiktok.getAuthUrl.query();
  if (error_0 || !data_0?.url) {
    toast("Failed to start TikTok connection");
    return;
  }
  window.location.href = data_0.url;
}